import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatedParticles } from '../shared/AnimatedParticles';
import HeroActions from './HeroActions';
import {
  HeroSection,
  HeroContent,
  HeroTitle,
  HeroSubtitle,
  FloatingParticle,
  ParrotLogo
} from './styles';

interface HeroProps {
  onLoginClick?: () => void;
}

const Hero: React.FC<HeroProps> = ({ onLoginClick }) => {
  const { t } = useTranslation();

  const floatingParticles = React.useMemo(() =>
    Array.from({ length: 12 }, (_, i) => ({
      id: i,
      delay: i * 2,
      x: 10 + (i * 7),
      duration: 8 + (i % 4),
    })), []
  );

  return (
    <HeroSection id="hero">
      {/* Floating particles */}
      {floatingParticles.map((particle) => (
        <FloatingParticle
          key={particle.id}
          $delay={particle.delay}
          $x={particle.x}
          $duration={particle.duration}
        />
      ))}

      <AnimatedParticles />
      <ParrotLogo src="icons/logo_landing.webp" alt="Loopra Parrot" />

      <HeroContent>
        <HeroTitle>
          {t('hero.title')}
        </HeroTitle>

        <HeroSubtitle>
          {t('hero.subtitle')}
        </HeroSubtitle>

        <HeroActions onLoginClick={onLoginClick} />
      </HeroContent>
    </HeroSection>
  );
};

export default Hero;
